module.exports = __webpack_public_path__ + "static/bg-9736b8219465a00f4567716b87bae5ac.png";